import React from 'react';

import {isValidWaitingRoomSession} from '../../../data/filters/scheduleFilters';
import {useEvent} from '../../../data/hooks/eventHooks';
import {useNextSession, useSessionInProgress} from '../hooks';
import ParticipantBubbles from '../EventWaitingRoom/ParticipantBubbles/ParticipantBubbles';
import styles from './EmptySidePanel.module.scss';
import {useParams} from 'react-router';

const EmptySidePanel = props => {
    const {} = props,
        {eventId} = useParams(),
        event = useEvent(eventId),
        currentSession = useSessionInProgress(event.id),
        nextSession = useNextSession(event.id, {filter: isValidWaitingRoomSession});

    return (
        <div className={['fill-container', styles.EmptySidePanel].join(' ')}>
            <ParticipantBubbles event={event} session={currentSession || nextSession} />
        </div>
    );
};

export default EmptySidePanel;
